(() => {
  const apiBase = "https://gewinnspiel.elusa.de/api";
  const container = document.querySelector(".ec-content");
  const messageBox = document.getElementById("elusa-message");

  const showMsg = (msg, type = "info") => {
    const color = type === "error" ? "red" : type === "success" ? "green" : "#444";
    messageBox.innerHTML = `<p style="color:${color};margin:8px 0;">${msg}</p>`;
  };
  
  const setError = (input, msg) => {
    input.style.borderColor = "red";
    let err = input.nextElementSibling;
    if (!err || !err.classList.contains("field-error")) {
      err = document.createElement("div");
      err.className = "field-error";
      input.insertAdjacentElement("afterend", err);
    }
    err.textContent = msg;
  };
  const clearError = (input) => {
    input.style.borderColor = "";
    const err = input.nextElementSibling;
    if (err && err.classList.contains("field-error")) err.remove();
  };
  const attachLiveValidation = (inputEl) => {
    inputEl.addEventListener("input", () => clearError(inputEl));
    inputEl.addEventListener("change", () => clearError(inputEl));
  };
  function formatWinAmount(value) {
  if (!value) return "";
    const val = value.toUpperCase().trim();
    if (val.endsWith("EUR")) {
        return val.replace(/EUR$/i, "€");
    }
    if (val.includes("€")) return val;
    return value;
  }
  function isWinningCash(value) {
    if (!value) return false;
    const v = value.toUpperCase();
    return v.endsWith("EUR") || v.includes("€");
  }

  const buildRedeemForm = () => {
    container.innerHTML = `
      <form id="redeem-form" class="redeem-form-step-1">
        <p class="frm-txt">ERFAHRE DIREKT OB DU GEWONNEN HAST!</p>
        <div class="input-group">
          <input type="email" id="email" placeholder="Deine E-Mail" required class="redeem-input">
          <input type="text" id="orderNumber" placeholder="Bestellnummer" required class="redeem-input">
          <input type="text" id="code" placeholder="Dein Gewinncode" maxlength="10" required class="redeem-input">
          <label class="checkbox-container">
            <input type="checkbox" name="terms">
            <div class="chkbxTb">
            <span class="checkmark"></span>
            <span>Ich akzeptiere die <a href="https://elusa.de/pages/teilnahmebedingungen-gewinnspiel">Teilnahmebedingungen</a> des Gewinnspiels.</span>
            </div>
          </label>
          <button type="submit" class="submit-btn">GEWINNCODE PRÜFEN</button>
        </div>
      </form>
    `;

    const form = document.getElementById("redeem-form");
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const emailEl = document.getElementById("email");
      const orderEl = document.getElementById("orderNumber");
      const codeEl = document.getElementById("code");
      const termsEl = form.querySelector('input[name="terms"]');

      [emailEl, orderEl, codeEl].forEach(attachLiveValidation);
      termsEl.addEventListener("change", () => clearError(termsEl));

      const email = emailEl.value.trim();
      const orderNumber = orderEl.value.trim();
      const code = codeEl.value.trim();

      [emailEl, orderEl, codeEl].forEach(clearError);
      clearError(termsEl);
      messageBox.innerHTML = "";

      let hasError = false;
      if (!email) {
        setError(emailEl, "Bitte E-Mail angeben");
        hasError = true;
      }
      if (!orderNumber) {
        setError(orderEl, "Bitte Bestellnummer angeben");
        hasError = true;
      }
      if (!code || code.length !== 10) {
        setError(codeEl, "Bitte gültigen Code eingeben");
        hasError = true;
      }
      if (!termsEl.checked) {
        setError(termsEl, "Du musst die Teilnahmebedingungen akzeptieren");
        hasError = true;
      }
      if (hasError) {
        showMsg("Bitte überprüfe deine Eingaben.", "error");
        return;
      }

      showMsg("Sende Daten...");

      try {
        const query = new URLSearchParams({ email, orderNumber, code });
        const res = await fetch(`${apiBase}/redeem?${query}`, { method: "POST" });
        const data = await res.json().catch(() => null);
        console.log("Redeem response:", data);

        if (data?.success) {
          showMsg("Bitte prüfe deine E-Mails, um deine Teilnahme zu bestätigen. Wenn du keine E-Mail bekommst, schau bitte in deinen Spam Ordner. Ansonsten melde dich bei unserem Support.", "success");
          form.reset();
        } else {
          showMsg(data?.errorMsg || "Ungültige Eingabe, bitte erneut versuchen.", "error");
        }
      } catch (err) {
        console.error(err);
        showMsg("Verbindungsfehler, bitte später erneut versuchen.", "error");
      }
    });
  };

  const buildBankForm = (win, code, secret) => {
    container.innerHTML = `
      <form id="bank-form" class="redeem-form-step-2">
        <p class="frm-txt" id="winningtxt">GLÜCKWUNSCH 🎉<br>DU HAST ${formatWinAmount(win) || "Won"} GEWONNEN!</p>
        <p class="frmt-dsc">Gebe hier deine Bankdetails an um deine Auszahlung zu bekommen.</p>
        <div class="input-group">
          <input type="text" id="owner" placeholder="Name" required class="redeem-input">
          <input type="text" id="iban" placeholder="IBAN" required class="redeem-input">
          <input type="text" id="bic" placeholder="BIC" required class="redeem-input">
          <button type="submit" class="submit-btn">JETZT AUSZAHLEN LASSEN</button>
        </div>
      </form>
    `;

    const form = document.getElementById("bank-form");
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const ownerEl = document.getElementById("owner");
      const ibanEl = document.getElementById("iban");
      const bicEl = document.getElementById("bic");
      [ownerEl, ibanEl, bicEl].forEach(attachLiveValidation);
      const owner = ownerEl.value.trim();
      const iban = ibanEl.value.trim();
      const bic = bicEl.value.trim();

      [ownerEl, ibanEl, bicEl].forEach(clearError);
      messageBox.innerHTML = "";

      let hasError = false;
      if (!owner) {
        setError(ownerEl, "Bitte Name eingeben");
        hasError = true;
      }
      if (!iban) {
        setError(ibanEl, "Bitte IBAN eingeben");
        hasError = true;
      }
      if (!bic) {
        setError(bicEl, "Bitte BIC eingeben");
        hasError = true;
      }
      if (hasError) {
        showMsg("Bitte überprüfe deine Eingaben.", "error");
        return;
      }

      showMsg("Sende Bankdaten...");
      try {
        const query = new URLSearchParams({ secret, code, iban, bic, owner });
        const res = await fetch(`${apiBase}/sendBankDetails?${query}`, { method: "POST" });
        const data = await res.json().catch(() => null);
        console.log("Bank response:", data);

        if (data?.success) {
          showMsg("Bankdaten erfolgreich übermittelt. Die Überweisung erfolgt in den nächsten Tagen.", "success");
          form.reset();
        } else {
          showMsg(data?.errorMsg || "Fehler beim Senden der Bankdaten.", "error");
        }
      } catch (err) {
        console.error(err);
        showMsg("Netzwerkfehler. Bitte später erneut versuchen.", "error");
      }
    });
  };

  const buildNoWin = (winText = "") => {
    //let discountInfo = "";
    //if (winText && winText.toLowerCase().includes("rabattcode")) {
    //  discountInfo = `<p class="frmt-dsc">${winText.replace(/\+/g, " ")}</p>`;
    //} else {
    //  discountInfo = `<p class="frmt-dsc">Hier aber ein 5% Gutschein für die nächste Bestellung:</p>`;
    //}

    container.innerHTML = `
      <div class="redeem-form-step-3">
        <p class="frm-txt">DU HAST LEIDER NICHT GEWONNEN.</p>
        <p class="frmt-dsc-1">WIR SCHENKEN DIR ABER TROTZDEM EINEN 10€ GUTSCHEIN!</p>
        <p class="frmt-dsc">Du kannst den Code bis Ende des Jahres einlösen, gültig ab 40€</p>
		<div class="voucher-box">
        Dein Gutscheincode: <span id="voucher-code">XTCMT55SJ</span>

		  </div>
        <div class="input-group">
          <a class="submit-btn" href="https://elusa.de/collections/neu">WEITER SHOPPEN</a>
        </div>
      </div>
    `;

      const voucherEl = document.getElementById("voucher-code");
  voucherEl.style.cursor = "pointer";
  voucherEl.title = "Zum Kopieren klicken";

  voucherEl.addEventListener("click", async () => {
    try {
      await navigator.clipboard.writeText(voucherEl.textContent.trim());
      voucherEl.style.color = "green";
      voucherEl.textContent = "Kopiert!";
      setTimeout(() => {
        voucherEl.style.color = "";
        voucherEl.textContent = "XTCMT55SJ";
      }, 1500);
    } catch (err) {
      console.error("Kopieren fehlgeschlagen:", err);
      alert("Kopieren nicht möglich. Bitte manuell kopieren.");
    }
  });
  };

  const params = new URLSearchParams(window.location.search);
  const secret = params.get("secret");
  const code = params.get("code");
  const win = params.get("win");

  if (secret && code) {
    if (isWinningCash(win)) {
      buildBankForm(win, code, secret);
    } else {
      buildNoWin();
    }
  } else {
    buildRedeemForm();
  }
})();